module.exports = __webpack_public_path__ + "img/microsoft-for-startups.b5c63cfc.png";